import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Collapse,
  IconButton,
  Typography,
  Grid,
  TextField
} from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const WhyChooseUs = ({
  formData,
  handleChange,
  expanded,
  toggleSection
}) => {
  return (
    <Card
      elevation={3}
      sx={{
        mb: 3,
        borderLeft: '6px solid #e91e63',
        borderRadius: 2,
        backgroundColor: '#fdfdfd'
      }}
    >
      <CardHeader
        avatar={<StarIcon sx={{ color: '#e91e63' }} />}
        title={
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#000' }}>
            Why Choose Us
          </Typography>
        }
        action={
          <IconButton onClick={() => toggleSection('features')}>
            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        }
        sx={{
          backgroundColor: '#fce4ec',
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
          py: 1.5,
          px: 2
        }}
      />
      <Divider />
      <Collapse in={expanded}>
        <CardContent sx={{ px: 3, py: 2 }}>
          <Grid container spacing={4}>
            {[1, 2, 3, 4].map((num) => (
              <Grid item xs={12} sm={6} key={num}>
                <TextField
                  label={`Feature ${num}`}
                  name={`whychoose_${num}`}
                  value={formData[`whychoose_${num}`]}
                  onChange={handleChange}
                  fullWidth
                  multiline
                  rows={3}
                  variant="outlined"
                  helperText={`Describe feature ${num}`}
                  InputLabelProps={{ shrink: true }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      '& fieldset': {
                        borderColor: '#f48fb1'
                      },
                      '&:hover fieldset': {
                        borderColor: '#f06292'
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#e91e63'
                      }
                    }
                  }}
                />
              </Grid>
            ))}
          </Grid>
        </CardContent>
      </Collapse>
    </Card>
  );
};

export default WhyChooseUs;
